import CreateChatSvg from './CreateChat.svg';
import styles from './CreateChat.module.css'
import { useNavigate } from 'react-router-dom';
import { clearMessages } from '../../redux/message/actions.js';
import { useDispatch } from 'react-redux';

function CreateChat() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(clearMessages());
    navigate('/');
  }

  return (
    <button className={styles.layout} onClick={handleClick}>
        <p>Create Chat</p>
        <img src={CreateChatSvg} alt="Create Chat" className={styles.icon}/>
    </button>    
  );
}

export default CreateChat;